<template>
  <div :class="['shadow', bg, size]">
    <div
      v-if="$attrs.head || $attrs.subtitle"
      :class="['border-b border-secondary-light', spacing]"
    >
      <div class="flex items-center justify-between">
        <h2 :class="['leading-6 font-semibold', fontTitle]">
          {{ $t(`mygwf.components.Card.${$attrs.head}`) }}
        </h2>
        <slot name="action">
          <base-button-icon
            v-if="hasBack"
            @click="$router.back()"
            icon="close"
            class="bg-secondary"
          />
        </slot>
      </div>
      <p v-if="$attrs.subtitle" class="mt-1 leading-5 text-gray-500">
        {{ $t(`mygwf.components.Card.${$attrs.head}.subtitle`, {id: $attrs.subtitle}) }}
      </p>
    </div>
    <div :class="[spacing]">
      <slot />
    </div>
    <div v-if="$scopedSlots.footer" :class="['bg-secondary flex space-x-3 justify-end', spacing]">
      <slot name="footer" />
    </div>
  </div>
</template>

<script>
import BaseButtonIcon from './_base-button-icon.vue'
import {cardStyle} from '@/state/helpers/mixins.js'

export default {
  components: {BaseButtonIcon},
  mixins: [cardStyle],
  props: {
    hasBack: {
      type: Boolean,
      default: false,
    },
  },
}
</script>
